import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";
import { resetPassword } from "../auth/resetPassword";

// Extrae el mensaje legible del backend (HttpsError v2) para mostrarlo en
// pantalla. Busca en: error.details (string u objeto), luego en el prefijo
// "code: mensaje" de error.message. Nunca devuelve el genérico si hay detalle.
const callableErrorMessage = (error) => {
  if (!error) return "Error desconocido";

  let details = error.details;
  if (details === undefined || details === "function failed") {
    details = typeof error.message === "string" ? error.message : "";
    const match = details.match(/^[\w/-]+:\s*(.+)$/);
    if (match) return match[1];
    return details && details !== "internal"
      ? details
      : "Ocurrió un error al crear el miembro.";
  }

  if (typeof details === "string") return details;
  if (details && typeof details.message === "string") return details.message;
  return "Ocurrió un error al crear el miembro.";
};

export const createDealershipMember = async (memberData) => {
  try {
    const createMemberFn = httpsCallable(functions, "createUnitMembershipV2");
    const safeMemberData = { ...(memberData || {}) };
    delete safeMemberData.confirmPassword;
    safeMemberData.requestedApp = "dealership_web";
    const result = await createMemberFn(safeMemberData);
    const response = result.data;
    let invitationSent = null;
    if (response?.data?.invitationRequired === true) {
      const invitation = await resetPassword(safeMemberData.email);
      invitationSent = invitation.success === "yes";
    }
    const message = invitationSent === false
      ? "La membresía fue creada, pero no se pudo enviar el email de acceso. Enviá un restablecimiento de contraseña manualmente."
      : response?.otherRole
        ? `Membresía creada. La persona ya existía como ${response.otherRole.role} (${response.otherRole.email}). Se creó una cuenta separada de miembro.`
        : "Membresía creada correctamente.";
    return { ...response, message, invitationSent };
  } catch (error) {
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: callableErrorMessage(error),
      code: error.code || null,
    };
  }
};
